const ring = (i, w, h) => ({
  id: `ring${i}`, type: "rect", x: i, y: i, w: w - 2 * i, h: h - 2 * i, rotation: 0, opacity: 1,
  fill: "transparent", stroke: i === 0 ? "#DC2626" : "#0F172A", strokeWidth: i === 0 ? 0.3 : 0.15, radius: 0,
});

const label = (id, x, y, text, size = 3.2, extra = {}) => ({
  id, type: "text", x, y, w: 4, h: 2, rotation: 0, opacity: 1, text, fontSize: size, fontWeight: 700,
  color: "#0F172A", align: "center", fontFamily: "JetBrains Mono", lineHeight: 1, ...extra,
});

function side(w, h, name) {
  const els = [];
  for (let i = 0; i <= 5; i++) els.push(ring(i, w, h));
  for (let i = 1; i <= 5; i++) {
    els.push(label(`lt${i}`, w / 2 - 2, i - 1.1, String(i)));
    els.push(label(`ll${i}`, i - 2.6, h / 2 - 0.9, String(i)));
    els.push(label(`lr${i}`, w - i - 1.4, h / 2 - 0.9, String(i)));
    els.push(label(`lb${i}`, w / 2 + 3, h - i + 0.1, String(i)));
  }
  const cx = w / 2, cy = h / 2;
  els.push({ id: "ch", type: "rect", x: cx - 6, y: cy - 0.1, w: 12, h: 0.2, fill: "#0F172A", rotation: 0, opacity: 1 });
  els.push({ id: "cv", type: "rect", x: cx - 0.1, y: cy - 6, w: 0.2, h: 12, fill: "#0F172A", rotation: 0, opacity: 1 });
  els.push(label("title", 8, cy + 7, `CALIBRATION · ${name}`, 5, { w: w - 16, h: 3 }));
  els.push(label("hint", 8, cy + 11, "Red = card edge · rings every 1 mm", 3.5, { w: w - 16, h: 3, fontWeight: 500 }));
  els.push(label("up", 8, cy - 11, "▲ TOP", 4, { w: w - 16, h: 3 }));
  return { background: "#FFFFFF", elements: els };
}

export const makeCalibrationTpl = (w, h) => ({
  name: "Calibration", width: w, height: h, double_sided: true,
  front: side(w, h, "FRONT"), back: side(w, h, "BACK"),
});
